import './productionRuntimeFixes.css';

// Runtime UI corrections are implemented inside React components.
// Do not observe or rescan the complete document: that previously caused
// repeated class mutations and UI freezes on Inward and More Modules.
if (typeof document !== 'undefined') {
  document.body?.classList.remove(
    'final-simple-inward-open',
    'final-hd-route',
    'final-outward-route',
    'final-weather-route',
    'final-mixed-hd-workspace',
  );
}
